<template>
  <div>
    <div class="searchBox">
      <div class="searchLeft">
        <el-date-picker
        size="medium"
          v-model="searchForm.date"
          type="date"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptionsStart"
          placeholder="请选择开始时间">
        </el-date-picker>
        <!-- <el-date-picker
          size="medium"
          v-model="searchForm.endTime"
          type="date"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptionsEnd"
          placeholder="请选择结束时间">
        </el-date-picker> -->
        <el-button size="medium" type="primary" icon="el-icon-search" @click="getTableList">搜索</el-button>
        <!-- <a :href="url+'/coinPrice/pledgeGasDaily/export?startTime='+searchForm.startTime + '&&endTime='+searchForm.endTime" style="margin-left:20px">
          <el-button size="medium" type="warning" icon="el-icon-folder-opened">导出</el-button>
        </a> -->
      </div>
      <div class="searchLeft">
        <p style="margin-left:20px;display:inline-block;">
          <span>当前生效质押：</span>
          <span style="color:red;font-size:20px;">{{configData&&configData.salePledge?configData.salePledge+' FIL':0}}</span>
        </p>
        <p style="margin-left:20px;display:inline-block;">
          <span>当前生效Gas：</span>
          <span style="color:red;font-size:20px;">{{configData&&configData.saleGas?configData.saleGas+' FIL':0}}</span>
        </p>
      </div>
    </div>
    <el-table
      border
      :data="tableData"
      height="73vh"
      style="width: 100%">
      <!-- <el-table-column
        width="160"
        label="充币时间">
        <template slot-scope="scope">
          <span>{{$selfFunc.dayjsFunc(scope.row.doneTime)}}</span>
        </template>
      </el-table-column> -->
      <el-table-column
        prop="browserPledge"
        label="浏览器平均质押">
      </el-table-column>
      <el-table-column
        prop="browserGas"
        label="浏览器平均Gas">
      </el-table-column>
      <el-table-column
        prop="salePledge"
        label="销售质押">
      </el-table-column>
      <el-table-column
        prop="saleGas"
        label="销售Gas">
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="抓取数据时间">
      </el-table-column>
      <el-table-column
        prop="activeTime"
        label="生效时间">
        <template slot-scope="scope">
          {{scope.row.activeTime?scope.row.activeTime:'-'}}
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        width="100px"
        label="操作">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" v-if="scope.row.editable" @click="openShow(scope.row)"><i class="el-icon-view" style="margin-right:3px;"></i>编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pageBox" v-if="totalNum > 0">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.page"
        :page-sizes="[16, 32, 50, 60]"
        :page-size="searchForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
      >
      </el-pagination>
    </div>
    <el-dialog
      title="编辑"
      :visible.sync="dialogVisible"
      width="450px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="132px" class="demo-ruleForm">
          <el-form-item label="销售质押" prop="salePledge">
            <el-input placeholder="请输入销售质押" v-model="ruleForm.salePledge" style="width:220px" type="number"></el-input>
          </el-form-item>
          <el-form-item label="销售Gas" prop="saleGas">
            <el-input placeholder="请输入销售Gas" v-model="ruleForm.saleGas" style="width:220px" type="number"></el-input>
          </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    var checkNum = (rule, value, callback) => {
      if (value==='') {
        return callback(new Error('输入不能为空'));
      }else {
        if (value !=parseInt(value)) {
          callback(new Error('输入必须为正整数'));
        } else if (value < 0) {
          callback(new Error('输入不能为负值'));
        } else {
          callback();
        }
      }
    };
    var checkNum1 = (rule, value, callback) => {
      if (value==='') {
        return callback(new Error("请输入正确的数值"));
      } else if (value <= 0) {
        callback("输入必须为正数");
      }else {
        callback()
      }
    };
    return {
      pickerOptionsStart: {
        disabledDate: time => {
          let endDateVal = this.searchForm.endTime;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime();
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.searchForm.startTime;
          if (beginDateVal) {
            return (time.getTime()<new Date(beginDateVal).getTime()-1*24*60*60*1000);
          }
        }
      },
      totalNum:0,
      searchForm:{
        page:1,
        pageSize:16,
        date: null,
      },
      dialogVisible: false,
      tableData: [],
      options: [
        { name: "全部", value: 0 },
        { name: "服务中", value: 1 },
        { name: "待服务", value: 2 },
        { name: "已结束", value: 3 },
      ],
      userId: '',
      balance: 0,
      balanceTwo: 0,
      url: window.g.host,
      configData: null,
      ruleForm: {
        id: null,
        saleGas: null,
        salePledge: null
      },
      rules:{
        salePledge: [
          { required: true, message: '请输入销售质押', trigger: 'blur' },
        ],
        saleGas: [
          { required: true, message: '请输入销售Gas', trigger: 'blur' },
        ],
      },
    };
  },
  created() {
    this.getTableList()
    this.getConfig()
  },
  methods: {
    openShow(row) {
      this.ruleForm.id = row.id
      this.ruleForm.saleGas = row.saleGas
      this.ruleForm.salePledge = row.salePledge
      this.dialogVisible = true
    },
    submitForm(formName) {
      let _this = this
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let res = await _this.$http.updatePledgeGasAvg({..._this.ruleForm});
          if (res) {
            _this.$message.success('操作成功！');
            _this.dialogVisible=false;
            _this.ruleForm.saleGas = ''
            _this.ruleForm.salePledge = ''
            _this.getTableList()
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    async getConfig(){
      let res = await this.$http.pledgeGas();
      if (res) {
        console.log(res)
        this.configData = res.data
      }
      
    },
    goDetl(id) {
      this.$router.push({name:'orderIncomeDaily',query:{orderId:id}})
    },
    async getTableList(val){
      if(val){
        this.searchForm.page=1;
      }
       let res = await this.$http.pledgeGasPageList({...this.searchForm});
        if (res) {
          this.tableData=res.data.list
          console.log(res.data)
          this.totalNum=Number(res.data.totalSize)
        }
    },
    handleSizeChange(val) {
      this.searchForm.page = 1;
      this.searchForm.pageSize = val;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getTableList();
    }
  }
};
</script>
<style scoped>
.unit{
  position: absolute;
  right: 10px;
  color:#999;
}
</style>
